// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/extensions/v1/message_options.proto (package quanterix.common.extensions.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MessageOptions } from "../../../../google/protobuf/descriptor_pb";
import { file_google_protobuf_descriptor } from "../../../../google/protobuf/descriptor_pb";
import type { CustomOptions } from "./custom_options_pb";
import { file_quanterix_common_extensions_v1_custom_options } from "./custom_options_pb";

/**
 * Describes the file quanterix/common/extensions/v1/message_options.proto.
 */
export const file_quanterix_common_extensions_v1_message_options: GenFile = /*@__PURE__*/
  fileDesc("CjRxdWFudGVyaXgvY29tbW9uL2V4dGVuc2lvbnMvdjEvbWVzc2FnZV9vcHRpb25zLnByb3RvEh5xdWFudGVyaXguY29tbW9uLmV4dGVuc2lvbnMudjE6gwEKE21lc3NhZ2VfbWFwX29wdGlvbnMSHy5nb29nbGUucHJvdG9idWYuTWVzc2FnZU9wdGlvbnMY0IYDIAEoCzItLnF1YW50ZXJpeC5jb21tb24uZXh0ZW5zaW9ucy52MS5DdXN0b21PcHRpb25zUhFtZXNzYWdlTWFwT3B0aW9uc4gBAWIGcHJvdG8z", [file_google_protobuf_descriptor, file_quanterix_common_extensions_v1_custom_options]);

/**
 * Custom options for mapping protobuf messages
 *
 * @generated from extension: optional quanterix.common.extensions.v1.CustomOptions message_map_options = 50000;
 */
export const message_map_options: GenExtension<MessageOptions, CustomOptions> = /*@__PURE__*/
  extDesc(file_quanterix_common_extensions_v1_message_options, 0);

